import { Grid, Typography } from "@mui/material";
import {
  CandidateDetails,
  JobRequestDetails,
} from "../../../redux/Hire/jobRequestApi";
import { useGetTaskForCandidateAtStageQuery } from "../../../redux/Task/TaskApi";
import {
  CODE_MAP,
  usePollingWithRefetch,
} from "../CandidateDetails/DetailsHeader";
import CandidateResume from "../Compoenents/CandidateResume";
import DisqualifyCandidate from "../Compoenents/DisqualifyCandidate";
import MoveCandidate from "../Compoenents/MoveCandidate";
import RestoreCandidate from "../Compoenents/RestoreCandidate";

type Props = {
  candidate?: CandidateDetails;
  job?: JobRequestDetails;
};

const CandidateInfoHeader = ({ candidate, job }: Props) => {
  const enabled = !!candidate?.id && !!candidate?.jobId && !!candidate?.stage;

  const { data: taskData, refetch } = useGetTaskForCandidateAtStageQuery(
    {
      CandidateId: candidate?.id?.toString() || "",
      JobId: candidate?.jobId || "",
      StageCode: CODE_MAP[candidate?.stage || ""]
        ? CODE_MAP[candidate?.stage || ""]
        : candidate?.stage || "",
    },
    {
      skip: !enabled,
    },
  );

  usePollingWithRefetch({
    enabled,
    result: taskData?.data?.result,
    refetch,
    deps: [candidate?.id, candidate?.jobId, candidate?.stage],
    maxRetries: 5,
    interval: 3000,
  });
  return (
    <Grid container direction="column" rowGap={1} bgcolor={"#fff"} p={2}>
      <Typography
        fontSize={"14px"}
        lineHeight={"14px"}
        fontWeight={"600"}
        color={"#0F1829"}
      >
        {job?.client}'s Open Position
      </Typography>
      <Grid container justifyContent={"space-between"} alignItems="center">
        <Typography fontSize={"24px"} fontWeight={700} color={"#3F4871"}>
          {job?.title}
        </Typography>
      </Grid>
      <CandidateResume candidate={candidate} />
      <Grid container item justifyContent={"space-between"} alignItems="center">
        <Grid item xs={5}>
          {candidate?.disqualified ? (
            <>
              <Typography fontSize={"14px"} color={"#0F1829"}>
                Candidate has been disqualified with the following reason:
              </Typography>
              <Typography fontSize={"14px"} fontWeight={700} color="error">
                {candidate.disqualificationReason || "No reason provided"}
              </Typography>
            </>
          ) : (
            <Typography fontSize={"14px"} fontWeight={500} color={"#0F1829"}>
              Candidate is currently in the{" "}
              {camelCaseToNormal(candidate?.stage || "") || "N/A"} stage
            </Typography>
          )}
        </Grid>
      </Grid>
      {taskData?.data.result ? (
        <Grid container item mt={2} gap={2}>
          <DisqualifyCandidate
            candidate={candidate}
            task={taskData?.data?.result}
          />
          <MoveCandidate task={taskData?.data?.result} candidate={candidate} />
        </Grid>
      ) : candidate?.disqualified ? (
        <Grid item>
          <RestoreCandidate candidate={candidate} />
        </Grid>
      ) : (
        <Typography fontSize={"14px"} color={"#667086"}>
          No Task Found
        </Typography>
      )}
    </Grid>
  );
};

// Converts a camelCase or snake_case string to normal text (e.g., "jobTitle" or "job_title" -> "Job Title")
export function camelCaseToNormal(str: string): string {
  if (!str) return "";
  return str
    .replace(/_/g, " ") // Replace underscores with spaces
    .replace(/([A-Z])/g, " $1") // Add space before capital letters
    .replace(/\s+/g, " ") // Replace multiple spaces with single space
    .replace(/^./, (s) => s.toUpperCase()) // Capitalize first letter
    .trim();
}

export default CandidateInfoHeader;
